import { createStandardAction } from "typesafe-actions";
import { Dispatch, Reducer } from "redux";
import { ActionsUnion } from "./types";

export interface SetDatePayload {
  readonly date: Date;
}

export interface BadgesState {
  whatsNew: {
    lastChecked: Date | null;
  };
}

export const badgesInitialState: BadgesState = {
  whatsNew: {
    lastChecked: null
  }
};

export const resetWhatsNewBadge = () => (dispatch: Dispatch) => {
  // Write the date to storage for next time but clear the store to hide the badge
  const now = new Date();
  localStorage.setItem("wn", now.toISOString());

  dispatch(badgesActions.clearWhatsNewBadge());
};

export const badgesActions = {
  setWhatsNewDate: createStandardAction("BADGES/WHATS_NEW/SET_DATE")<
    SetDatePayload
  >(),
  resetWhatsNewBadge: resetWhatsNewBadge,
  clearWhatsNewBadge: createStandardAction("BADGES/WHATS_NEW/CLEAR")(),
  clearBadges: createStandardAction("BADGES/CLEAR")()
};

export const badgesReducer: Reducer<BadgesState, ActionsUnion> = (
  state = badgesInitialState,
  action
): BadgesState => {
  switch (action.type) {
    case "BADGES/CLEAR": {
      return {
        ...badgesInitialState
      };
    }
    case "BADGES/WHATS_NEW/SET_DATE": {
      return {
        ...state,
        whatsNew: {
          lastChecked: action.payload.date
        }
      };
    }
    case "BADGES/WHATS_NEW/CLEAR": {
      return {
        ...state,
        whatsNew: {
          lastChecked: null
        }
      };
    }
  }
  return state;
};
